import React from 'react';
import {NavLink, useNavigate} from "react-router-dom";
import './Login.css'
import {
    Button,
    FormControl,
    Grid, IconButton,
    InputAdornment,
    InputLabel, Link,
    OutlinedInput,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";

import jwt from 'jwt-decode'

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import Recaptcha from "react-google-recaptcha";
import logo from '../../assets/images/logo.png'
import {useEffect, useState} from "react";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {RouteInfo} from "../../route/RouteHelper";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../../context/reducer";
import {setUserRefreshToken, setUserToken} from "../../service/localStorage/LocalStorageService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {LoginService} from "./LoginService";
import {CashService} from "../CashInfo/CashService";
import {GeneralService} from "../generalAdmin/GeneralService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

const Login = () => {

    const snackbarState = useSnackbarDispatcher()
    const token = useAuthState().token
    const loading = useLoadingDispatcher()

    const service = new LoginService()

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof token !== "undefined" && token !== null) {
            navigate(RouteInfo.Dashboard.url)
        }
    }, [token, navigate])

    const [passwordValue, setPasswordValue] = useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const [username, setUsername] = useState('');

    const [showSubmitCode, setShowSubmitCode] = useState(false);
    const [submitCode, setSubmitCode] = useState("");

    const handleChange = (prop) => (event) => {
        setPasswordValue({...passwordValue, [prop]: event.target.value});
    };

    const handleClickShowPassword = () => {
        setPasswordValue({...passwordValue, showPassword: !passwordValue.showPassword});
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const [isVerified, setIsVerified] = useState(false);
    const verifyCallback = () => {
        setIsVerified(true)
    }

    const dispatch = useAuthDispatcher()

    function doSendSms() {
        if (username.length > 0 && passwordValue.password.length > 0) {
            loading(setLoadingStateDispatch(true))
            service.sendSms(username, passwordValue.password)
                .then(response => {

                    if (response.status === "SENT") {
                        setShowSubmitCode(true)
                        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, "کد تایید با موفقیت ارسال شد."))
                        loading(setLoadingStateDispatch(false))
                    } else {
                        loading(setLoadingStateDispatch(false))
                        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در ارسال کد تایید!"))
                    }

                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری یا رمز عبور اشتباه می باشد."))
            })

        } else {
            snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری و رمز عبور خود را به درستی وارد نمایید."))
        }
    }

    function doUserLogin() {
        if (username.length > 0 && submitCode.length > 0) {
            loading(setLoadingStateDispatch(true))
            service.loginUser(username, submitCode)
                .then(response => {

                    getAvailableCashList(response.data)

                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "کد تایید وارد شده صحیح نمی باشد!"))
            })

        } else
            snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "کد تایید خود را به درستی وارد نمایید."))
    }

    function getAvailableCashList(loginInfo) {
        if (jwt(loginInfo.access_token).total_owner === true) {
            new GeneralService(
                loginInfo.access_token,
                loading,
                snackbarState
            ).getAvailableCashList(0, 1)
                .then(response => {
                    if (response.data.length > 0) {
                        setUserLoginState(loginInfo, response.data[0].id, response.data[0].name, true)
                    }
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت لیست صندوق های در دسترس", snackbarState, loading)
            })
        } else {
            new CashService(
                loginInfo.access_token,
                loading,
                snackbarState
            ).getAvailableCashList()
                .then(response => {
                    if (response[0]) {
                        setUserLoginState(loginInfo, response[0].id, response[0].name, false)
                    } else {
                        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "مدیریت هیچ صندوقی به شما تعلق نگرفته است!"))
                        loading(setLoadingStateDispatch(false))
                    }
                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات صندوق"))
            })
        }


    }

    function setUserLoginState(loginInfo, fundId, title, totalOwner) {
        setUserRefreshToken(loginInfo.refresh_token)

        dispatch(
            setLoginStateDispatch(
                actionTypes.LOGIN,
                loginInfo.access_token,
                "ADMIN",
                fundId,
                title,
                totalOwner))

        loading(setLoadingStateDispatch(false))
    }

    function handleLoginActions() {
        if (showSubmitCode)
            doUserLogin()
        else
            doSendSms()
    }

    return (
        // <>{
        // tokenState.token === null && !tokenState.loading ?
        <Grid xs={12} id="login-container">
            <Grid style={{width: "100%"}} xs={11} sm={9} md={6} lg={5} xl={3}>
                <Paper id='login-paper' elevation='2'>
                    <img
                        src={logo}
                        alt='raiko'
                    />

                    <Typography
                        variant='h6'
                    >
                        سامانه مدیریت صندوق های مردمی
                    </Typography>
                    <Typography
                        variant='subtitle2'
                        style={{marginTop: '8px', marginBottom: '1rem'}}
                    >
                        {
                            showSubmitCode ?
                                "لطفا کد تایید ارسال شده را وارد نمایید!" :
                                "لطفا برای ورود نام کاربری و رمز عبور خود را وارد نمایید!"
                        }
                    </Typography>
                    {!showSubmitCode && <TextField
                        variant='outlined'
                        label='نام کاربری'
                        value={username}
                        onChange={e => {
                            setUsername(e.target.value)
                        }}
                    />}
                    {!showSubmitCode && <FormControl variant="outlined" className='w-100'>
                        <InputLabel htmlFor="outlined-adornment-password">رمز عبور</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={passwordValue.showPassword ? 'text' : 'password'}
                            value={passwordValue.password}
                            onChange={handleChange('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {passwordValue.showPassword ? <Visibility/> : <VisibilityOff/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}

                            onKeyUp={e => {
                                if (e.key === 'Enter') {
                                    handleLoginActions()
                                }
                            }}

                        />
                    </FormControl>}

                    {showSubmitCode && <TextField
                        variant='outlined'
                        label='کد تایید'
                        type={"number"}
                        value={submitCode}
                        onChange={e => {
                            setSubmitCode(e.target.value)
                        }}

                        onKeyUp={e => {
                            if (e.key === 'Enter') {
                                handleLoginActions()
                            }
                        }}
                    />}

                    {/*<div
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            padding: "1rem 0 0 0"
                        }}
                        className="w-100">
                        <Recaptcha
                            className='g-recaptcha'
                            sitekey="6LcfFhsfAAAAAK8t0DGlVbxX8trHyM3tmBnfU-5B"
                            render="explicit"
                            onChange={verifyCallback}
                            hl="fa"
                        />
                    </div>*/}
                    <Button className="btn-confirm"
                            onClick={handleLoginActions}
                    >
                        {showSubmitCode ? "ورود" : "ارسال کد تایید"}
                    </Button>

                    {showSubmitCode ?
                        <span className="fs-0 cursorPointer"
                              onClick={_ => {
                                  setSubmitCode("")
                                  setShowSubmitCode(false)
                              }}>اصلاح اطلاعات ورود</span> :
                        <NavLink
                            className="fs-0"
                            to={RouteInfo.ForgetPassword.globalUrl}
                        >
                            رمز عبور خود را فراموش کرده اید ؟!
                        </NavLink>}

                    <Typography
                        variant='caption'
                        id='copyrightContainer'
                    >
                        <Link
                            href="https://raiko.app"
                            target='_blank'
                            color='inherit'
                            style={{textDecoration: "none"}}
                        >
                            {/*raiko.app@2021 All rights reserved*/}
                            ساخته شده با ❤️ توسط رایکو
                        </Link>
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
        // :
        //         tokenState.token !== null && !tokenState.loading ?
        //             <Navigate to={RouteInfo.Root.globalUrl}/> :
        //             ''
        //
        // }
        // </>
    )
};

export default Login;

